import React, { useEffect, useState } from 'react';
import { Categories, Header, Items, SearchBar, Layout } from './components';
import useScrollPosition from '@react-hook/window-scroll';
import { useSearch } from './hooks';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  styles: {
    global: {
      '.video-react-fluid': {
        padding: '0!important',
      },
      '.bpb': {
        display: 'none',
      },
    },
  },
});

export function Main({ getGiphyGifData, onDragStart, onDragEnd }: any) {
  const { loading, data, loadNextPage, search } = useSearch();
  const scroll = useScrollPosition();
  const [query, setQuery] = useState('');

  useEffect(() => {
    search(query);
  }, [query]);

  useEffect(() => {
    var totalPageHeight = document.body.scrollHeight;
    var scrollPoint = window.scrollY + window.innerHeight;

    if (scrollPoint >= totalPageHeight) {
      loadNextPage();
    }
  }, [scroll]);

  const handleSubmit = (newQuery: any) => {
    setQuery(newQuery);
  };

  return (
    <ChakraProvider theme={theme}>
      <Layout
        header={<Header />}
        searchBar={
          <SearchBar query={query as string} onSubmit={handleSubmit} />
        }
      >
        {query === '' ? (
          <Categories onSelectCategory={handleSubmit} />
        ) : (
          <Items
            items={data}
            getGiphyGifData={getGiphyGifData}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
          />
        )}
      </Layout>
    </ChakraProvider>
  );
}
